import { DialogTitle } from '@mui/material';

interface DialogTitleProps {
  children?: React.ReactNode;
}

export const lookoDialogHeaderClassName = 'LookoDialogHeaderV2';

/**
 * 모달 헤더.
 */
export default function DialogHeader({ children }: DialogTitleProps) {
  return (
    <DialogTitle
      variant="H2_Looko"
      className={lookoDialogHeaderClassName}
      sx={{ borderBottom: theme => `1px solid ${theme.palette.divider}`, px: 4, py: 2.5 }}
    >
      {children}
    </DialogTitle>
  );
}
